import React from 'react'
import PropTypes from 'prop-types'
import { cx } from '@emotion/css'
import styles, { currentTheme } from './styles'

const PlacementItem = ({ className, heading, isCurrent, count, theme }) => (
  <li className={cx(className, styles.counter)}>
    <span className={cx(isCurrent && currentTheme(theme), count === 0 && styles.empty, styles.count)}>{count}</span>
    {heading}
  </li>
)

PlacementItem.propTypes = {
  className: PropTypes.string,
  heading: PropTypes.string.isRequired,
  theme: PropTypes.string,
  count: PropTypes.number.isRequired,
  isCurrent: PropTypes.bool,
}

export default PlacementItem
